import { EventsService } from "@app/services/events.service"
import { PermsService } from "./../services/perms.service"
import { LangService } from "@app/services/lang.service"
import { ActivatedRoute } from "@angular/router"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { Injectable } from "@angular/core"

@Injectable({
	providedIn: "root",
})
export class MenuService {
	menu: any[] = []
	constructor(
		public modalService: ModalService,
		public lang: LangService,
		public route: ActivatedRoute,
		public store: StoreService,
		public permsService: PermsService,
		public eventsService: EventsService
	) {
		this.menu = [
			{ lang: "calendar", icon: "main_calendar", link: "calendar" },
			{
				lang: "financial",
				icon: "financial",
				id: "financial",
				children: [
					{
						lang: "income",
						icon: "income",
						report_name: "invoices_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: "follow_ups_report",
						icon: "patient",
						report_name: "followups_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: this.permsService.owner_has_users
							? "rent_report"
							: "contacts_meetings",
						icon: "contact",
						report_name: "rent_report",
						id: "rent_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: "locations_report",
						icon: "rent",
						report_name: "locations_report",
						id: "locations_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: "invoices_sub_user_report",
						id: "invoices_sub_user_report",
						icon: "income",
						report_name: "invoices_sub_user_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: "followups_sub_user_report",
						id: "followups_sub_user_report",
						icon: "sub_user",
						report_name: "followups_sub_user_report",
						isReportsModal: true,
						//perms: ["administrative"],
					},
					{
						lang: "followups_sub_user_rent_report",
						id: "followups_sub_user_rent_report",
						icon: "rent",
						report_name: "followups_sub_user_rent_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					// {
					//   lang: "patients_sub_user_report",
					//   id: "patients_sub_user_report",
					//   icon: "report",
					//   //modal: "sub-user-patients",
					//   report_name: "patients_sub_user_report",
					//   isReportsModal: true,
					// },
					{
						lang: "patients_sub_user_report",
						id: "patients_sub_user_report",
						icon: "patient",
						modal: "sub-user-patients",
						name: "sub-user-patients",
					},
					{
						lang: "sub_user_payments",
						id: "sub_user_payments",
						icon: "payments",
						modal: "sub-user-payments",
						name: "sub-user-payments",
						perms: ["finances_income", "administrative"],
					},
					{
						lang: "text_report",
						icon: "mixed_list",
						report_name: "followups_text_report",
						isReportsModal: true,
						perms: ["clinical"],
					},
					{
						lang: "debts_report",
						icon: "report",
						id: "debts_report",
						report_name: "debts_report",
						isReportsModal: true,
						perms: ["administrative"],
					},
					{
						lang: "debts_report",
						icon: "debt",
						id: "debts_report2",
						report_name: "debts_report2",
						isReportsModal: true,
						perms: ["administrative"],
					},
					// {
					//   lang: "real_debt",
					//   icon: "report",
					//   report_name: "real_debt_report",
					//   isReportsModal: true,
					// },

					{
						lang: "insert_expenses",
						icon: "expense",
						link: "table2/expenses",
						name: "expenses",
						perms: ["finances_expenses"],
					},
					{
						lang: "expenses_report",
						icon: "expenses_report",
						report_name: "expenses_report",
						isReportsModal: true,
						perms: ["finances_expenses"],
					},
					{
						lang: "profitloss_report",
						icon: "profitloss_report",
						modal: "profitloss",
						name: "profitloss",
						perms: ["finances_income"],
					},
					{
						lang: "proformas_report",
						icon: "proformas_report",
						report_name: "proformas_report",
						isReportsModal: true,
						perms: ["finances_income", "administrative"],
					},
					{
						lang: "justinvoices_report",
						icon: "justinvoices_report",
						report_name: "justinvoices_report",
						isReportsModal: true,
						perms: ["finances_income", "administrative"],
					},
					{
						lang: "taxes_calc",
						icon: "tax",
						modal: "taxes-report",
						name: "taxes-report",
						perms: ["finances_income"],
					},
					{
						lang: "irs_journal_report",
						icon: "irs_journal_report",
						report_name: "followups_all_report",
						isReportsModal: true,
					},

					// { lang: 'irs',
					//   icon: 'report',
					//   modal: "bkmvdata-report",
					//   perms: ["administrative"] },
					// { lang: 'irs', icon: 'irs', report_name: 'irs', isReportsModal: true },
					// {
					//   lang: "export",
					//   icon: "export",
					//   modal: "data-export",
					//   perms: ["administrative"],
					// },

					{
						lang: "graphs",
						icon: "graph",
						modal: "graphs-data",
						name: "graphs-data",
						perms: ["finances_income", "administrative"],
					},
					// { lang: "graphs", icon: "graph", modal: "graphs-data" },

					{
						lang: "supervisor_notes",
						icon: "supervisor_notes",
						id: "supervisor_notes",
						modal: "followups-for-supervisor-list",
						name: "followups-for-supervisor-list",
						perms: ["authorized_signer", "clinical_admin"],
					},
				],
			},
			{
				lang: "configuration",
				icon: "setting",
				id: "config-cliniq",
				link: "config-cliniq?showMenu=1",
				children: [
					{
						lang: "configcliniqs",
						icon: "setting2",
						link: "config-cliniq?showMenu=1",
						perms: ["administrative"],
					},
					{ lang: "report_problem", icon: "bug", modal: "error" },
					{
						lang: "email_tracking",
						icon: "email",
						link: "table/notifications",
					},
					// for therapist it's own{
					// {
					//   lang: "sms_tracking",
					//   icon: "sms",
					//   link: "table/smslogs",
					// }, // for therapist it's own
					{
						lang: "sign",
						icon: "sign_document",
						id: "sign-documents",
						modal: "sign-documents",
						perms: ["authorized_signer"],
					},
					{ lang: "patients", icon: "patient", link: "table/patients" },
					{ lang: "inquirers", icon: "patient", link: "table/inquirers" },
					{ lang: "groups", icon: "group", link: "table/groups" }, // add is_group as filter
					{
						lang: "sub_users_dashboard",
						icon: "group",
						id: "sub_users",
						link: "table/sub_users",
						perms: ["administrative"],
					},
					{
						lang: "contacts",
						icon: "contact",
						link: "table/contacts",
						perms: ["administrative"],
					},
					{
						lang: "payors",
						icon: "payor",
						link: "table/payors",
						perms: ["finances_income"],
					},
					{ lang: "meeting_times", icon: "times", modal: "meeting-times" },
					{
						lang: "home-admin",
						icon: "setting2",
						link: "home-super-admin",
						id: "home-super-admin",
					},

					//	{ lang: "add", icon: "setting2", modal: "types-create" },
				],
			},
			//{ lang: "tasks", icon: "notifications", modal: "task",        name: "tasks", },
		]

		const cc = this.store.cc()
		const isSuperAdmin = cc?.role == 2
		let old_debts_report = cc.old_debts_report == "yes" ? true : false
		if (cc.invoice_per_followup == "no") {
			old_debts_report = true
		}

		this.removeForPerms(this.menu)

		const has2HP =
			this.permsService.owner_has_users &&
			this.permsService.perms?.sees_admin_homepage &&
			this.permsService.perms?.clinical
		if (has2HP) {
			if (!this.menu.find((it) => it?.id == "home")) {
				this.menu.unshift({
					lang: "home",
					id: "home",
					icon: "home",
					children: [
						{ lang: "clinical_home", icon: "home-grey", link: "home" },
						{ lang: "home-admin", icon: "tasks", link: "home-admin" },
					],
				})
			}
		} else if (
			!this.permsService.owner_has_users ||
			(this.permsService.owner_has_users &&
				!this.permsService.perms.sees_admin_homepage)
		) {
			if (!this.menu.find((it) => it?.id == "home")) {
				this.menu.unshift({
					lang: "home",
					id: "home",
					icon: "home",
					link: "home",
				})
			}
		} else {
			if (!this.menu.find((it) => it?.id == "home")) {
				this.menu.unshift({
					lang: "home",
					id: "home",
					icon: "home",
					link: "home-admin",
				})
			}
		}

		if (!this.permsService.owner_has_users) {
			let configuration = this.menu.find((it) => it?.id == "config-cliniq")
			if (configuration) {
				configuration.children = configuration.children.filter(
					(it) => it?.id != "sub_users"
				)
				configuration.children = configuration.children.filter(
					(it) => it?.id != "sign-documents"
				)
			}

			let financial = this.menu.find((it) => it?.id == "financial")
			if (financial) {
				financial.children = financial.children.filter(
					(it) => it?.id != "followups_sub_user_report"
				)
				financial.children = financial.children.filter(
					(it) => it?.id != "followups_sub_user_rent_report"
				)
				financial.children = financial.children.filter(
					(it) => it?.id != "invoices_sub_user_report"
				)
				financial.children = financial.children.filter(
					(it) => it?.id != "patients_sub_user_report"
				)
				// financial.children = financial.children.filter(
				//   (it) => it?.id != "rent_report"
				// );
				financial.children = financial.children.filter(
					(it) => it?.id != "locations_report"
				)
				financial.children = financial.children.filter(
					(it) => it?.id != "sub_user_payments"
				)
				financial.children = financial.children.filter(
					(it) => it?.id != "supervisor_notes"
				)
			}
		}

		if (!isSuperAdmin) {
			let configuration = this.menu.find((it) => it?.id == "config-cliniq")
			if (configuration) {
				configuration.children = configuration.children.filter(
					(it) => it?.id != "home-super-admin"
				)
			}
		}

		if (!old_debts_report) {
			let financial = this.menu.find((it) => it?.id == "financial")
			if (financial) {
				financial.children = financial.children.filter(
					(it) => it?.id != "debts_report"
				)
			}
		}
		if (old_debts_report) {
			let financial = this.menu.find((it) => it?.id == "financial")
			if (financial) {
				financial.children = financial.children.filter(
					(it) => it?.id != "debts_report2"
				)
			}
		}

		this.menu.forEach((it) => {
			if (this.lang.getConfigVal("img." + it.icon)) {
				it.isImg = true
			}
			if (it.children) {
				it.children.forEach((it2) => {
					if (this.lang.getConfigVal("img." + it2.icon)) {
						it2.isImg = true
					}
					if (it2.children) {
						it2.children.forEach((it3) => {
							if (this.lang.getConfigVal("img." + it3.icon)) {
								it3.isImg = true
							}
						})
					}
				})
			}
		})

		this.hideShowMenuItems()

		this.store.hiddenMenuItemsSubj.subscribe(() => this.hideShowMenuItems())
	}

	hideShowMenuItems() {
		const cc = this.store.cc()
		const reports = cc?.reports
		if (!reports) {
			return
		}

		this.menu
			.filter((it) => it.children)
			.forEach((it) => {
				it.children.forEach((it2) => {
					if (it2.lang in reports) {
						it2.hiddenCc = !reports[it2.lang]
					}
				})
			})
	}
	removeForPerms(arrItems: any[]) {
		for (let item of arrItems) {
			if (item.perms) {
				if (this.permsService.hasMissingPerm(item.perms)) {
					item.hidden = true
				}
			}
			if (item.children) {
				this.removeForPerms(item.children)
			}
		}
	}
}
